export const routeForTarget = (target) => {
  if (target?.orderId) {
    return {
      path: `/my-orders/detail?id=${target.orderId}`,
      state: target.orderNumber ? { orderNumber: target.orderNumber } : undefined,
    };
  }

  if (target?.masterOrderId) {
    return { path: "/my-orders", state: undefined };
  }

  return null;
};
